import { render, staticRenderFns } from "./SharedSelection.vue?vue&type=template&id=0f60016e&scoped=true"
import script from "./SharedSelection.vue?vue&type=script&lang=js"
export * from "./SharedSelection.vue?vue&type=script&lang=js"
import style0 from "./SharedSelection.vue?vue&type=style&index=0&id=0f60016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60016e",
  null
  
)

export default component.exports